import React from 'react'
import './MarketingTemplateStyle.css'
import useMarketingTemplate from './useMarketingTemplate'
import TemplateList from './List/TemplateList.component'
import TemplatePreview from './Preview/TemplatePreview.component'

const MarketingTemplate: React.FC = () => {
  const hooks = useMarketingTemplate()

  return (
    <div
      className={`marketing-template${hooks.showPreview ? ' marketing-template--editor' : ''}`}
    >
      {hooks.showPreview ? (
        <div className="marketing-template-editor-frame">
          <TemplatePreview />
        </div>
      ) : (
        <TemplateList />
      )}
    </div>
  )
}

export default MarketingTemplate
